import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from '@/shared/firebase'
import 'bootstrap/dist/css/bootstrap.min.css'
import _ from 'lodash'
import Notifications from 'vue-notification'
import EmmaConsole from '@/shared/EmmaConsole'

window.emma = EmmaConsole

Vue.set(Vue.prototype, '_', _)
Vue.use(Notifications)
Vue.config.productionTip = false

import copyToClipboard from '@/shared/copyToClipboard'
Vue.mixin(copyToClipboard)

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

Vue.directive('blur-on-click', {
  bind: function(el) {
    el.clickEvent = function(e) {
      e.target.blur()
    }
    el.addEventListener('click', el.clickEvent)
  },
  unbind: function(el) {
    el.removeEventListener('click', el.clickEvent)
  }
})

const requireComponent = require.context('./components', false, /Base[A-Z]\w+\.(vue|js)$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = _.upperFirst(
    _.camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

import Format from '@/shared/Format'
Vue.mixin(Format)

let appIsInitialized = false

auth.onAuthStateChanged(() => {
  if (!appIsInitialized) {
    appIsInitialized = true
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  if (auth.currentUser) {
    store.dispatch('bindAssets')
  } else {
    store.dispatch('unbindAssets')
    router.replace('/login')
  }
})
